import { useContext } from 'react';
import { ServerConfigContext } from './ServerConfigContext';

const useServerConfig = () => useContext(ServerConfigContext);

const useConfigItem = (name) => {
    const config = useContext(ServerConfigContext);
    return config?.[name] ?? [];
};

export { useServerConfig, useConfigItem };
